import { Directive, HostListener, inject, input } from '@angular/core';

import { OverlayService } from '@core/services';
import { BannerPictureType } from '@core/models';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { BreakpointFacade } from '@core/facades';

@Directive({
  selector: '[cheeleeOpenGetApp]',
  standalone: true,
})
export class OpenGetAppDirective {
  private readonly overlayService = inject(OverlayService);

  public preventDefault = input<boolean>(true);

  public picture = input<BannerPictureType>();

  public action = input<AnalyticsEventsEnum>();

  public eventName  = input<AnalyticsEventsEnum>();

  protected readonly isMobile = inject(BreakpointFacade).isMobile;

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent | TouchEvent): void {
    event.stopPropagation();
    if (this.preventDefault()) {
      event.preventDefault();
    }
    this.overlayService.openGetAppDialog(this.action()! ?? this.eventName()!, this.picture());
  }
}
